<template>
  <div>
    <ResidentialProperties
      v-model="comp"
      :type="type"
      :used="usedProperties"
      :filter="filterItems"
      :required-check="false"
      :model="model"
      v-bind="$attrs"
      v-on="$listeners"
      :sortable="false"
      :show-deleted-items="true"
      :create-label="$t('selectFieldsToEdit')"
      :parent="{
        sale: {
          type: saleType,
        },
      }"
      :disabled-fields="{ 'properties.propertyType': !Boolean(saleType) }"
    >
    </ResidentialProperties>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ValueComp } from '@/utils'
import ResidentialProperties from '@/components/Residential/Properties'
import CreateFields from '@/components/Residential/Properties/CreateFields'
import { i18n } from '@/i18n'
import { Query } from 'mingo'

const meta = {
  order: 3,
  label: i18n.t('residentialProperties'),
}

export { meta }
export default {
  props: {
    value: Array,
    type: {
      type: String,
      default: 'property',
    },
    model: {
      type: String,
      default: 'Residential',
    },
    propertyTypes: {
      type: Array,
      default: () => [],
    },
    saleTypes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      create: false,
    }
  },
  computed: {
    ...mapState('Project', ['item']),
    preventDeleteOn() {
      //prevent delte based on required properties
      return (this.$store.state.enums.ResidentialProperties || [])
        .filter(e => {
          if (!e.required) return false
          if (typeof e.required === 'boolean') return e.required

          if (
            this.propertyTypes.some(p => {
              return new Query(e.required).test({
                properties: [{ key: 'propertyType', value: p }],
              })
            })
          )
            return true
          return false
        })
        .map(i => i.key)
    },
    usedProperties() {
      const usedProperties = this.$path('metadata.siteSettings.allUsedResidentialProperties', this.item) || {}

      return Object.entries(usedProperties)
        .map(([key, value]) => ({
          ...value,
          value: null,
          label: value.label || this.$t(key),
          key: key,
          preventDelete: this.preventDeleteOn.includes(key) && value.type === this.type,
        }))
        .filter(this.filterItems)
    },

    saleType() {
      if (this.saleTypes.length > 1) return ''
      return this.saleTypes[0]
    },

    comp: ValueComp(),
    label: () => meta.label,
  },
  methods: {
    filterItems(p) {
      switch (this.type) {
        case 'facility':
          return p.type === 'facility'
        case 'property':
          return !(p.type === 'facility')
      }
      return false
    },
  },

  components: {
    CreateFields,
    ResidentialProperties,
  },
}
</script>
